import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { SegovPage } from 'src/app/app.routes';
import { EServico } from 'src/app/domain/enums/servico.enum';
import { ToastModel, ToastType } from 'src/app/domain/models/toast.model';
import { toastShow } from 'src/app/stateManagement/actions/toast.action';
import { ToastState } from 'src/app/stateManagement/reducers/toast.reducer';
import { TitulosServicos } from 'src/app/utils/common.collections';
import { CommonMessages } from 'src/app/utils/common.messages';
import { Tema, TemaClaro, TemaEscuro } from 'src/app/utils/temas';
import { environment } from 'src/app/environments/environment';
import { SegovSigepoHeaderComponent } from '../segov-sigepo-header/segov-sigepo-header.component';
import { SegovSigepoFooterComponent } from '../segov-sigepo-footer/segov-sigepo-footer.component';
import { OpcaoMenu } from 'src/app/domain/models/opcao-menu.model';
import { OpcaoMenuComIcone } from 'src/app/domain/models/opcao-menu-com-icone.model';
import { FooterMenu } from 'src/app/domain/models/footer-menu.model';
import { Subscription } from 'rxjs';
import { FilesDeviceService } from 'src/app/services/devices/files-device.service';
import { ObterArquivoPoliticaPrivacidadeState } from 'src/app/stateManagement/reducers/Sobre/obter-politica-privacidade.reducer';
import { selectDadosObterArquivoPoliticaPrivacidade } from 'src/app/stateManagement/selectors/Sobre/obter-arquivo-politica-privacidade.selector';
import { obterArquivoPoliticaPrivacidade, obterArquivoPoliticaPrivacidadeFinish } from 'src/app/stateManagement/actions/Sobre/obter-politica-privacidade.action';

@Component({
  selector: 'app-segov-sigepo-portal-body',
  standalone: true,
  imports: [
    SegovSigepoHeaderComponent,
    SegovSigepoFooterComponent
  ],
  template:
    `
  <div style="display: flex; flex-direction: column; min-height: 100vh;">
    <app-segov-sigepo-header
      [id]="'portal-header'"
      [srcLogo]="'logo.png'"
      [altLogo]="'Minas Gerais - Diário Oficial eletrônico'"
      [menus]="menusHeader"
      [menuAreaCliente] = "menuAreaCliente"
      [menuTopo]="menuTopo"
      [temas]="temas"
      (clickContraste)="onContrastClick($event)"
      ></app-segov-sigepo-header>
      <div [id]="'conteudo'">
        <ng-content></ng-content>
      </div>
      @if(!ocultarFooter) {
      <app-segov-sigepo-footer
        [id]="'portal-footer'"
        [exibirVersaoRelease]="exibirVersaoRelease"
        [versaoRelease]="versaoRelease"
        [linksUteis]="linksUteis"
        [emailTexto]="email"
        [telefonesTexto]="telefones"
        [menuPrincipal]="menusFooter" [socialMedia]="socialMediaFooter" style="margin-top: auto"></app-segov-sigepo-footer>
      }
  </div>
  `
})
export class SegovSigepoPortalBodyComponent implements OnDestroy, OnInit {

  @Input() ocultarFooter = false;
  subPoliticaPrivacidade: Subscription;

  constructor(
    private filesDeviceServer: FilesDeviceService,
    private storeToast: Store<{ toastState: ToastState }>,
    private readonly storeObterArquivoPoliticaPrivacidade: Store<{ obterArquivoPoliticaPrivacidadeState: ObterArquivoPoliticaPrivacidadeState }>) {
        this.subPoliticaPrivacidade = new Subscription();
    }

  ngOnInit(): void {
    this.subPoliticaPrivacidade = this.storeObterArquivoPoliticaPrivacidade.select(selectDadosObterArquivoPoliticaPrivacidade)
        .subscribe(result => {
            if(result?.dados){
              this.filesDeviceServer.openOrDownloadPDF(result?.dados, 'PoliticaDePrivacidade');
            }
        });
  }

  ngOnDestroy(): void {
    this.storeObterArquivoPoliticaPrivacidade.dispatch(obterArquivoPoliticaPrivacidadeFinish());
    this.subPoliticaPrivacidade.unsubscribe();
  }


  @HostListener('document:keydown.alt.1', ['$event'])
  conteudoAtalho() {
    const e = document.getElementById(this.menuTopo[0].nome);
    e?.click();
  }

  @HostListener('document:keydown.alt.2', ['$event'])
  menuAtalho() {
    const e = document.getElementById(this.menuTopo[1].nome);
    e?.click();
  }

  @HostListener('document:keydown.alt.3', ['$event'])
  buscaAtalho() {
    const e = document.getElementById(this.menuTopo[2].nome);
    e?.click();
  }

  @HostListener('document:keydown.alt.4', ['$event'])
  mapaDoSiteAtalho() {
    const e = document.getElementById(this.menuTopo[3].nome);
    e?.click();
  }

  onContrastClick($event: number) {
    this.storeToast.dispatch(
      toastShow(
        {
          toastModel: new ToastModel(
            CommonMessages.Success,
            $event === 0 ? "Contraste aplicado" : "Contraste original",
            ToastType.Success)
        }));
  }

  subMenusSobre: OpcaoMenu[] = [
    { nome: 'História do Jornal', rota: SegovPage.HistoriaJornal },
    { nome: 'Reportagens Históricas', rota: SegovPage.ReportagensIconicas },
  ];

  subMenusServicos: OpcaoMenu[] = [
    { nome: 'Publicação no Jornal', rota: SegovPage.Servicos, rotaParametros: TitulosServicos[EServico.publicacaoMateria].servico },
    { nome: 'Consulta ao Acervo', rota: SegovPage.Servicos, rotaParametros: TitulosServicos[EServico.consulta].servico },
    { nome: 'Ressarcimento de Valores', rota: SegovPage.Servicos, rotaParametros: TitulosServicos[EServico.ressarcimentoValores].servico },
    { nome: 'Gratuidade de Publicação', rota: SegovPage.Servicos, rotaParametros: TitulosServicos[EServico.gratuidadePublicacao].servico },
  ];

  subMenusAtendimentos: OpcaoMenu[] = [
    { nome: 'Canais de contato', rota: SegovPage.Atendimento },
    { nome: 'Calendário', rota: SegovPage.CalendarioPublicacao },
    { nome: 'Comunicados', rota: SegovPage.Comunicados },
    { nome: 'Glossário', rota: SegovPage.Glossario },
    { nome: 'Perguntas frequentes', rota: SegovPage.PerguntasFrequentes },
  ];

  menusHeader: OpcaoMenu[] = [
    { nome: 'Início', rota: SegovPage.Inicio, ocultarHeader: true },
    { nome: 'O Jornal', rota: SegovPage.EdicaoDoDia },
    { nome: 'Sobre', subMenus: this.subMenusSobre },
    { nome: 'Serviços', subMenus: this.subMenusServicos },
    { nome: 'Atendimento', subMenus: this.subMenusAtendimentos },
    { nome: 'Autenticidade', rota: SegovPage.Autenticidade }
  ];

  menuAreaCliente: OpcaoMenuComIcone =
    { src: "/icons/user-fill.svg", alt: "Ícone de usuário", nome: "Área do Cliente", rotaExterna: "https://diarioweb.mg.gov.br/newsys/src/interno/index.php/login_externos" };

  menusFooter: OpcaoMenu[] = [
    { nome: 'Início', rota: SegovPage.Inicio, ocultarHeader: true },
    { nome: 'O Jornal', rota: SegovPage.EdicaoDoDia },
    { nome: 'Sobre', rota: SegovPage.HistoriaJornal },
    { nome: 'Serviços', rota: SegovPage.Servicos },
    { nome: 'Atendimento', rota: SegovPage.Atendimento }
  ];

  menuTopo: OpcaoMenu[] = [
    { nome: 'Conteúdo [1]', rotaHref: 'conteudo' },
    { nome: 'Menu [2]', rotaHref: 'header-menu-principal' },
    { nome: 'Busca [3]', rota: SegovPage.PesquisaJornal },
    { nome: 'Mapa do site [4]', rotaHref: 'portal-footer' },
    { nome: 'Acessibilidade', rota: SegovPage.Acessibilidade }
  ];

  socialMediaFooter: FooterMenu[] = [
    { src: "/icons/icone-site.svg", alt: "Sítio Secretaria de Estado de Governo de Minas Gerais", url: "https://www.governo.mg.gov.br/" },
    { src: "/icons/instagram-fill.svg", alt: "instagram", url: "https://www.instagram.com/segov.mg/?hl=pt-br" }
  ];

  linksUteis: OpcaoMenu[] = [
    { nome: "Autenticidade", rota: SegovPage.Autenticidade },
    { nome: "Área do Cliente", rotaExterna: "https://diarioweb.mg.gov.br/newsys/src/interno/index.php/login_externos"},
    { nome: "Portal MG", rotaExterna: "https://www.mg.gov.br/" },
    { nome: "Políticas de Privacidade", customAction: () =>
      {
        this.storeObterArquivoPoliticaPrivacidade.dispatch(obterArquivoPoliticaPrivacidade())
      }
    },
  ];

 base64ToBlob(base64: string, mime: string): Blob {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mime });
}

  temas: Tema[] = [
    TemaClaro,
    TemaEscuro
  ]

  telefones: string[] = ["(31)3916-7075", "(31)3915-9221"];
  email = "jornalminasgerais@governo.mg.gov.br";

  exibirVersaoRelease = !environment.production;
  versaoRelease = environment.releaseVersion;
}
